<template>
<div class="work" id="work-8">
	<h2><span>02</span> Boomerang</h2>
	<div class="subtitle">
		<h3><span>Year</span>2025</h3>
		<h3><span>Product</span>App and Website</h3>
		<h3><span>Technology</span>Flutter / Wordpress / Figma</h3>
	</div>
	<blockquote>
		The market for recyclable materials presents a huge opportunity, which is also a challenge for Boomerang®, a new startup in the sustainable market. The app is still under development.<br/>
	</blockquote>
	<figure class="half">
		<img src="../../assets/boomerang_01.png" alt="boomerang mobile app">
		<img src="../../assets/boomerang_02.png" alt="boomerang mobile app">
		<img src="../../assets/boomerang_03.png" alt="boomerang mobile app">
	</figure>
	<figure class="int">
		<figcaption>
			<h3>Objective for this project</h3>
			<p>It's a completely new app without a comparable experience, so it was important to understand the diversity of users and create a user flow that would be simple and straightforward for all of them.</p>
			<h3>My Role</h3>
			<p>All product concepts, from user discovery to high-fidelity mockups, especially the navigation between different user roles, making it easy to interact.</p>
		</figcaption>
	</figure>
	<figure class="half">
		<figcaption>
			<h3>The Solution</h3>
			<p>Focusing on recyclable materials and user addresses for logistics was the central point of this versatile app's solution.</p>
			<p>Maintaining a traditional interface while adding features to enhance functionality and support all users.</p>
		</figcaption>
		<img src="../../assets/boomerang_04.png" alt="boomerang mobile app">
		<img src="../../assets/boomerang_04-1.png" alt="boomerang mobile app">
	</figure>
	<figure class="half">
		<figcaption>
			<blockquote>It's an exciting project where all the best design practices were applied to develop the final product designs.</blockquote> 
		</figcaption>
	</figure>
	<figure class="half">
		<img src="../../assets/boomerang_05.png" alt="boomerang mobile app">
		<img src="../../assets/boomerang_05-1.png" alt="boomerang mobile app">
		<img src="../../assets/boomerang_06.png" alt="boomerang mobile app">
	</figure>
	<blockquote>
		"Be ready for the release soon, it's going to be a game changer in the recycling market."
	</blockquote>
</div>
</template>
<style scoped>
  figure > img {
	border-radius: 60px;
  }
  .half {
	margin-top: 100px;
  }
</style>